var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEstrelinhaProduto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.48828 12.3066L2.84766 15.1191L4.07812 9.8457L0 6.29492L5.37891 5.83789L7.48828 0.880859L9.59766 5.83789L14.9766 6.29492L10.8984 9.8457L12.1289 15.1191L7.48828 12.3066Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEstrelinhaProduto);
export default __webpack_public_path__ + "static/media/estrelinhaProduto.bd2b78a53952687a5717821d6f0c115d.svg";
export { ForwardRef as ReactComponent };